import React, { useEffect, useState } from 'react';

const SlotFormModal = ({
  isDialogOpen,
  editingSlot,
  formData,
  setFormData,
  handleSubmit,
  resetForm,
  organizations,
  branches,
  equipments,
  services,
}) => {
  if (!isDialogOpen) return null;

  const title = editingSlot ? 'Editar Bloque de Tiempo' : 'Crear Nuevo Bloque de Tiempo';
  const inputClass = 'focus:ring-primary-main w-full rounded border bg-black px-3 py-2 focus:outline-none focus:ring';
  const selectClass = 'focus:ring-primary-main bg-primary-main w-full rounded border px-3 py-2 focus:outline-none focus:ring';

  const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Filtra sucursales basadas en la organización seleccionada (Mejora UX)
  const filteredBranches = branches.filter(b => b.fk_organization._id === formData.organizationId);

  return (
    <div className="fixed text-white inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-primary-dark max-w-xl rounded p-6 shadow-lg sm:w-full max-h-[90vh] overflow-y-auto">
        <h3 className="mb-4 text-xl font-semibold">{title}</h3>
        <form onSubmit={handleSubmit} className="space-y-4">

          <h4 className="font-bold text-lg text-blue-300 border-b border-gray-700 pb-1">Dominio y Asignación</h4>
          <div className="grid grid-cols-2 gap-4">

            {/* Organización */}
            <div>
              <label className="block text-sm font-medium">Organización</label>
              <select name="organizationId" value={formData.organizationId} onChange={handleFieldChange} className={selectClass} required disabled={!!editingSlot}>
                <option value="">Selecciona Org.</option>
                {organizations.map((org) => (<option key={org._id} value={org._id}>{org.name}</option>))}
              </select>
            </div>

            {/* Sucursal */}
            <div>
              <label className="block text-sm font-medium">Sucursal</label>
              <select name="branchId" value={formData.branchId} onChange={handleFieldChange} className={selectClass} required disabled={!!editingSlot}>
                <option value="">Selecciona Sucursal</option>
                {filteredBranches.map((b) => (<option key={b._id} value={b._id}>{b.name}</option>))}
              </select>
            </div>

            {/* Equipo */}
            <div>
              <label className="block text-sm font-medium">Equipo Asignado</label>
              <select name="fk_equipment" value={formData.fk_equipment} onChange={handleFieldChange} className={selectClass} required disabled={!!editingSlot}>
                <option value="">Selecciona Equipo</option>
                {equipments.map((e) => (<option key={e._id} value={e._id}>{e.name} ({e.model})</option>))}
              </select>
            </div>

            {/* Servicio (Procedimiento) */}
            <div>
              <label className="block text-sm font-medium">Servicio Preasignado</label>
              <select name="fk_service" value={formData.fk_service} onChange={handleFieldChange} className={selectClass} required disabled={!!editingSlot}>
                <option value="">Selecciona Servicio</option>
                {services.map((s) => (<option key={s._id} value={s._id}>{s.name}</option>))}
              </select>
            </div>
          </div>

          <h4 className="font-bold text-lg text-blue-300 border-b border-gray-700 pb-1 pt-4">Horario</h4>
          <div className="grid grid-cols-2 gap-4">

            {/* Hora de Inicio */}
            <div>
              <label className="block text-sm font-medium">Inicio</label>
              <input type="datetime-local" name="start" value={formData.start} onChange={handleFieldChange} className={inputClass} required />
            </div>

            {/* Hora de Fin */}
            <div>
              <label className="block text-sm font-medium">Fin</label>
              <input type="datetime-local" name="end" value={formData.end} onChange={handleFieldChange} className={inputClass} required />
            </div>

            {/* Urgencia */}
            <div className="col-span-1 flex items-center gap-6 pt-2">
              <label className="flex items-center space-x-2 text-sm">
                <input type="checkbox" name="urgency" checked={formData.urgency} onChange={handleFieldChange} />
                <span>Ranura de Urgencia</span>
              </label>
            </div>

            {/* Disponibilidad (Solo en edición) */}
            {editingSlot && (
              <div className="col-span-1 flex items-center gap-6 pt-2">
                <label className="flex items-center space-x-2 text-sm">
                  <input type="checkbox" name="is_available" checked={formData.is_available} onChange={handleFieldChange} />
                  <span>Disponible para Cita</span>
                </label>
              </div>
            )}
          </div>

          <div className="flex justify-end gap-2 pt-4">
            <button type="button" onClick={resetForm} className="rounded bg-red-700 px-4 py-2 text-white hover:bg-red-500">Cancelar</button>
            <button type="submit" className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-900">
              {editingSlot ? 'Actualizar Slot' : 'Crear Slot'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SlotFormModal;
